// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Item__Wrapper_Uy9P-","Title":"Item__Title_3QkpC","Image":"Item__Image_irhJg","Footer":"Item__Footer_yp0C3"};